import { useState } from "react";
import { useT } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api from "@/lib/api";
import { Lock } from "lucide-react";

export default function Settings() {
  const { t, lang, setLang } = useT();
  const { user } = useAuth();
  const [saving, setSaving] = useState(false);


  return (
    <div className="p-8 lg:p-12 max-w-3xl fade-up">
      <div className="mb-10">
        <div className="text-[10px] uppercase tracking-[0.35em] text-white/40">{t("settings")}</div>
        <h1 className="font-serif text-5xl mt-2">{t("settings")}</h1>
      </div>

      <div className="space-y-4">
        <Card>
          <div className="text-[10px] uppercase tracking-widest text-white/40 mb-1">account</div>
          <div className="font-serif text-2xl">{user?.email}</div>
          <div className="text-xs text-white/40 mt-1">{user?.role}</div>
        </Card>


        <Card>
          <div className="text-[10px] uppercase tracking-widest text-white/40 mb-3">{t("language")}</div>
          <div className="flex gap-2">
            {["sk", "en"].map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                data-testid={`btn-lang-${l}`}
                className={`px-5 py-2.5 text-xs uppercase tracking-widest border ${
                  lang === l ? "border-white bg-white/5 text-white" : "border-white/10 text-white/50 hover:text-white"
                }`}
              >
                {l === "sk" ? "Slovenčina" : "English"}
              </button>
            ))}
          </div>
        </Card>

        <Card>
          <div className="text-[10px] uppercase tracking-widest text-white/40 mb-3">
            {lang === "sk" ? "Manuál na stiahnutie" : "Download manual"}
          </div>
          <a
            href="/manual.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="link-download-manual"
            className="inline-flex items-center gap-2 px-5 py-3 border border-fuchsia-500/30 bg-fuchsia-500/10 text-fuchsia-200 hover:bg-fuchsia-500/20 text-xs uppercase tracking-widest"
          >
            📕 Stiahnuť PDF manuál
          </a>
          <div className="text-xs text-white/40 mt-3">
            {lang === "sk"
              ? "Kompletný manuál (6 strán): prepojenia, AI chatbot a persona, Vault, automatické PPV ponuky, kredity, riešenie problémov."
              : "Complete user manual — all features, connections, AI settings, troubleshooting."}
          </div>
        </Card>

        <Card>
          <div className="text-[10px] uppercase tracking-widest text-white/40 mb-1">app</div>
          <div className="font-serif text-xl">dash creator panel</div>
          <div className="text-xs text-white/40 mt-1">v0.2 · unified inbox + AI persona</div>
        </Card>
      </div>
    </div>
  );
}

function Card({ children }) {
  return <div className="bg-[rgb(18,20,28)] border border-white/5 p-6">{children}</div>;
}
